import { PenumbraState } from './state.js';
// custom event tools
export const createPenumbraStateEvent = (penumbraOrigin, penumbraState) => new CustomEvent('penumbrastate', {
    detail: {
        origin: penumbraOrigin,
        state: penumbraState,
    },
});
// custom event type guards
/** Type guard for `PenumbraStateEvent`. The `restrictOrigin` parameter is purely
 * informational - anyone may create an event with any origin label. */
export const isPenumbraStateEvent = (evt, restrictOrigin) => evt instanceof CustomEvent && isPenumbraStateEventDetail(evt.detail, restrictOrigin);
export const isPenumbraStateEventDetail = (detail, restrictOrigin) => typeof detail === 'object' &&
    detail !== null &&
    'origin' in detail &&
    typeof detail.origin === 'string' &&
    (!restrictOrigin || detail.origin === restrictOrigin) &&
    'state' in detail &&
    typeof detail.state === 'string' &&
    Object.keys(PenumbraState).includes(detail.state);
